import React from 'react';
import { Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María Fernández',
  role: 'Docente hace 15 años',
  city: 'Buenos Aires',
  age: 42,
  quote: 'Antes pasaba los domingos planificando. Con este material, recuperé mis fines de semana y mis alumnos están más enganchados que nunca.',
  color: 'bg-blue-50'
}, {
  name: 'Carlos Rodríguez',
  role: 'Profesor de Economía',
  city: 'Córdoba',
  age: 38,
  quote: 'Lo que más valoro es el orden. Los chicos entienden hacia dónde vamos. El módulo de Cultura Organizacional es excelente.',
  color: 'bg-orange-50'
}, {
  name: 'Laura Martínez',
  role: 'Docente Nivel Medio',
  city: 'Rosario',
  age: 35,
  quote: 'Las rúbricas de evaluación me salvaron la vida a la hora de cerrar notas. Muy práctico y bien organizado.',
  color: 'bg-green-50'
}, {
  name: 'Roberto González',
  role: 'Jefe de Departamento',
  city: 'Mendoza',
  age: 51,
  quote: 'En 20 años de docencia, nunca vi un material tan bien organizado. Cubre todo el programa oficial pero de una forma moderna.',
  color: 'bg-purple-50'
}, {
  name: 'Silvina López',
  role: 'Profe principiante',
  city: 'La Plata',
  age: 29,
  quote: 'Empecé este año y estaba perdida. Este material me dio la seguridad que necesitaba para pararme frente al curso.',
  color: 'bg-yellow-50'
}];
export function TestimonialsSection() {
  return <section className="py-10 md:py-14 px-4 bg-white" data-id="element-446">
      <div className="max-w-6xl mx-auto" data-id="element-447">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-448">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-449">
            Lo que dicen otros docentes
          </h2>
          <p className="text-base text-gray-600" data-id="element-450">
            Colegas de todo el país ya están usando este sistema
          </p>
        </div>

        {/* Testimonials Grid - compact */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-451">
          {TESTIMONIALS.map((t, i) => <div key={i} className={`p-5 rounded-xl ${t.color} border border-gray-100 relative`} data-id="element-452">
              <Quote className="absolute top-4 right-4 h-6 w-6 text-gray-300 opacity-50" data-id="element-453" />

              <div className="flex items-center gap-2 mb-3" data-id="element-454">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-xs flex-shrink-0" data-id="element-455">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-456">
                  <p className="font-bold text-gray-900 text-sm leading-none" data-id="element-457">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-458">
                    {t.city} • {t.age} años
                  </p>
                </div>
              </div>

              <p className="text-gray-700 italic text-sm leading-relaxed mb-2" data-id="element-459">
                "{t.quote}"
              </p>

              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-460">
                {t.role}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}